import React from 'react';
import classes from './signedDocument.module.css';

const SignedDocuments = (props) => {
    const { isEnglish } = props;
    
    const handleKidChange = (index, value) => {
        const updatedKids = [...props.kids];

        if (value === "" || value === null) {
            updatedKids.splice(index, 1);
        } else {
            updatedKids[index] = value;
        }

        props.setKids(updatedKids.filter((kid) => kid));
    };
    return (
        <div className={classes.declarationContainer}>
            <div className={classes.textDeclarationTitle}>
                {isEnglish ? "Declaration By The Guardian" : "إقرار الوصي"}
            </div>
            <div className={classes.signatureSection}>
                <span>{isEnglish ? "To be signed by the Guardians" : "ليتم توقيعه من قبل الأوصياء"}</span>
                <div className={classes.redDot}>*</div>
            </div>
            <div className={classes.iText}>
                {isEnglish ? "I," : "أنا،"}
                <div className={classes.inputLine}>
                    <input placeholder={isEnglish ? 'Enter your name' : 'أدخل اسمك'} onChange={(e) => props.setName(e.target.value)} />
                    <div className={classes.redDot}>*</div>
                </div>
            </div>
            <div className={classes.inputGroup}>
                <span>{isEnglish ? "of address" : "العنوان"}</span>
                <div className={classes.inputLine}>
                    <input placeholder={isEnglish ? 'Enter your address' : 'أدخل عنوانك'} onChange={(e) => props.setAddress(e.target.value)} />
                    <div className={classes.redDot}>*</div>
                </div>
            </div>
            <div className={classes.inputGroup}>
                <span>{isEnglish ? "and email" : "والبريد الإلكتروني"}</span>
                <div className={classes.inputLine}>
                    <input type='email' placeholder={isEnglish ? 'Enter your email' : 'أدخل بريدك الإلكتروني'} onChange={(e) => props.setEmail(e.target.value)} />
                    <div className={classes.redDot}>*</div>
                </div>
            </div>
            <div className={classes.responsibilityText}>
                {isEnglish ? "being a person having parental responsibility for" : "بصفتي شخصًا يتحمل المسؤولية الأبوية عن"}
            </div>
            <div className={classes.inputLine}>
                <input
                    placeholder={isEnglish ? "First kid name" : "اسم الطفل الأول"}
                    value={props.kids[0] || ""} 
                    onChange={(e) => handleKidChange(0, e.target.value)} 
                />
                <div className={classes.redDot}>*</div>
            </div>
            <div className={classes.andText}>{isEnglish ? "and" : "و"}</div>
            <div className={classes.inputLine}>
                <input
                    placeholder={isEnglish ? "Second kid name" : "اسم الطفل الثاني"}
                    value={props.kids[1] || ""} 
                    onChange={(e) => handleKidChange(1, e.target.value)} 
                />
                <div className={classes.redDot}>*</div>
            </div>
            <div className={classes.certifyText}>
                {isEnglish ? (
                    ", and certify that the above details are correct and that in consideration of 6 Yard's acceptance of the Entrant's entry into the 6 Yard, the receipt and sufficiency of which consideration is acknowledged, hereby release and forever discharge 6 Yard, its owners, directors, officers, employees, agents, assigns, legal representatives, and successors from all manner of actions, causes of action, debts, accounts, bonds, contracts, claims, and demands for or by reason of any injury to the Entrant which has been or may be sustained as a consequence of an incident occurring at the 6 Yard or arising from the Entrant's participation in the 6 Yard."
                ) : (
                    "، وأشهد أن التفاصيل المذكورة أعلاه صحيحة وأنه بالنظر إلى قبول 6 Yard لدخول المشارك إلى 6 Yard، والذي يتم الإقرار باستلامه وكفايته، أبرئ ذمة 6 Yard ومالكيها ومديريها ومسؤوليها وموظفيها ووكلائها والمعينين والممثلين القانونيين والخلفاء من جميع أنواع الإجراءات وأسباب الإجراءات والديون والحسابات والروابط والعقود والمطالبات والمطالب بسبب أي إصابة للمشارك التي تم أو قد يتم تكبدها نتيجة لحادث وقع في 6 Yard أو ناشئ عن مشاركة المشارك في 6 Yard."
                )}
            </div>
            <div className={classes.waiverText}>
                {isEnglish ? (
                    "I hereby further declare that the terms of this waiver are fully understood; that the amount or type of consideration stated consideration is accepted voluntarily for the purpose of making a full and final compromise and settlement of all claims for injuries, losses, and damages which may result from the aforementioned incident or the Entrant's participation in the 6 Yard."
                ) : (
                    "أعلن بموجب هذا أن شروط هذا التنازل مفهومة تمامًا؛ وأن مقدار أو نوع المقابل المذكور يتم قبوله طواعية لغرض إجراء تسوية كاملة ونهائية لجميع المطالبات المتعلقة بالإصابات والخسائر والأضرار التي قد تنجم عن الحادث المذكور أو مشاركة المشارك في 6 Yard."
                )}
            </div>
            <div className={classes.signBelowText}>
                {isEnglish ? "Please sign in the field below" : "يرجى التوقيع في الحقل أدناه"}
            </div>
            <div className={classes.inputSignature}>
                <input className={classes.signatureName} placeholder={isEnglish ? 'Signature' : 'التوقيع'} onChange={(e) => props.setSignature(e.target.value)} />
                <div className={classes.redDot}>*</div>
            </div>
        </div>
    );
}

export default SignedDocuments;